import React, { useEffect } from "react";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape14 from "../../images/shape-14.png";

import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import author from "../../images/author-03.jpg";
import group from "../../images/group.jpg";
import logoIcon from "../../images/logo-icon.png";
import blog3 from "../../images/blog3.jpg";
import cer1 from "../../images/carousel1.png";
import cer2 from "../../images/carousel2.png";
import cer3 from "../../images/carousel3.png";
import cer4 from "../../images/carousel4.png";
import cer5 from "../../images/carousel5.png";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectFade,
  EffectCube,
  EffectFlip,
  Autoplay,
  EffectCoverflow,
} from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import "swiper/css/effect-cube";

import { useRef } from "react";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <Navbar/> */}
      {/* <div class="overlay"></div> */}

      <div className="section "></div>
      <div class="section page-banner">
        <div
          style={{
            backgroundColor: "rgba(0,0,0,0.4)",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            class="container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div class="page-banner-content">
              {/* <ul class="breadcrumb">
                        <li><a>Home</a></li>
                        <li class="active">About</li>
                    </ul> */}
              <h2 class="title" style={{ color: "#fff" }}>
                Our <span>Story.</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="section-padding-02 mt-n10">
          <div class="container" style={{ padding: "100px 0px 0px 0px" }}>
            <div class="row">
              <div class="col-lg-6">
                <h3
                  style={{
                    padding: "0.75rem",
                    fontSize: "46px",
                    fontWeight: "900",
                    fontFamily: "Playfair Display",
                    lineHeight: "1.1em",
                    color: "#25283a",
                    margin: "0 0 5px 0",
                  }}
                >
                  Real-World Experience, Real-World Success: How Maps Medics are
                  Changing the Game.
                </h3>
                <p
                  style={{
                    textAlign: "justify",
                    padding: "0.75rem",
                    fontWeight: "400",
                    margin: "0 0 24px 0",
                    fontSize: "15px",
                    fontFamily: "Poppins",
                    lineHeight: "1.1em",
                    color: "#383838",
                  }}
                >
                  At Maps Medics, we believe in the power of education to
                  transform lives. That is why we have created an on-demand
                  e-learning platform that is dedicated to helping medical
                  students succeed.
                </p>
                <p
                  style={{
                    textAlign: "justify",
                    padding: "0.75rem",
                    fontWeight: "400",
                    margin: "0 0 24px 0",
                    fontSize: "15px",
                    fontFamily: "Poppins",
                    lineHeight: "1.1em",
                    color: "#383838",
                  }}
                >
                  Our video lectures incorporate a case-based approach that
                  allows students to understand how medical concepts are applied
                  in real-world situations, and simulate the USMLE experience
                  from day one, giving them the skills and knowledge, they need
                  to succeed in their careers.
                </p>
                {/* 
                <div class="about-images">
                    <div class="images">
                        <img src={group} alt="About"/>
                    </div>

                    <div class="about-years">
                        <div class="years-icon">
                            <img src={logoIcon} alt="About"/>
                        </div>
                        <p><strong>6+</strong> Years Experience</p>
                    </div>
                </div> */}
              </div>
              <div class="col-lg-6">
                <div class="about-content" style={{ margin: "0" }}>
                  {/* <h5 class="sub-title">Welcome to Edule.</h5> */}
                  {/* <h4 class="main-title">Real-World Experience, Real-World Success: How Maps Medics Are <span>Changing The Game.</span></h4> */}
                  <p
                    style={{
                      textAlign: "justify",
                      padding: "0.75rem",
                      fontWeight: "400",
                      margin: "0 0 24px 0",
                      fontSize: "15px",
                      fontFamily: "Poppins",
                      lineHeight: "1.1em",
                      color: "#383838",
                    }}
                  >
                    With over 3,600 questions aligned with the USMLE course
                    outline, our comprehensive review covers the entire medical
                    curriculum in an orderly manner, with in-depth explanations
                    of correct and incorrect choices.
                  </p>
                  <p
                    style={{
                      textAlign: "justify",
                      padding: "0.75rem",
                      fontWeight: "400",
                      margin: "0 0 24px 0",
                      fontSize: "15px",
                      fontFamily: "Poppins",
                      lineHeight: "1.1em",
                      color: "#383838",
                    }}
                  >
                    We have made it our mission to make learning easy and
                    accessible for all students. That is why we use simple
                    language, bullet points, and color coding to break down
                    complex concepts and make them easy to understand.
                  </p>
                  <p
                    style={{
                      textAlign: "justify",
                      padding: "0.75rem",
                      fontWeight: "400",
                      margin: "0 0 24px 0",
                      fontSize: "15px",
                      fontFamily: "Poppins",
                      lineHeight: "1.1em",
                      color: "#383838",
                    }}
                  >
                    But we do not just provide the resources – we also offer
                    personalized support from a team of experienced educators
                    who are always available to mentor and guide you along the
                    way.
                  </p>
                  <p
                    style={{
                      textAlign: "justify",
                      padding: "0.75rem",
                      fontWeight: "400",
                      margin: "0 0 24px 0",
                      fontSize: "15px",
                      fontFamily: "Poppins",
                      lineHeight: "1.1em",
                      color: "#383838",
                    }}
                  >
                    At Maps Medics, we are committed to helping you succeed. We
                    have covered you whether you are just starting your medical
                    journey or looking to improve your skills. Save time and
                    money by getting everything you need in one place – choose
                    Maps Medics for all your medical education needs.
                  </p>
                  {/* <a href="#" class="btn btn-primary btn-hover-dark">Start A Course</a> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section-padding-02 mt-n6">
          <div
            class="container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              class="about-items-wrapper"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div class="row">



                {/*********************** */}
                <div class="col aboutItem">
                  <div class="about-item">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div class="item-icon-title">
                        <div class="item-icon">
                          <i class="fa-solid fa-briefcase-medical"></i>{" "}
                        </div>
                        <div class="item-title"></div>
                      </div>
                    </div>

                    <h3
                      className="title"
                      style={{
                        fontFamily: "Playfair Display",
                        fontSize: "20px",
                        fontWeight: "700",
                        textAlign: "center",
                      }}
                    >
                      Case-Based <br /> Approach
                    </h3>
                  </div>
                </div>
                                {/*********************** */}

                <div class="col aboutItem">
                  <div class="about-item">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div class="item-icon-title">
                        <div class="item-icon">
                          <i class="fa-solid fa-file-video"></i>
                        </div>
                        <div class="item-title"></div>
                      </div>{" "}
                    </div>
                    <h3
                      className="title"
                      style={{
                        fontFamily: "Playfair Display",
                        fontSize: "20px",
                        fontWeight: "700",
                        textAlign: "center",
                      }}
                    >
                      Comprehensive Video Library
                    </h3>
                  </div>
                </div>
                <div class="col aboutItem">
                  <div class="about-item">
                    {" "}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div class="item-icon-title">
                        <div class="item-icon">
                          <i class="fa-solid fa-circle-question"></i>
                        </div>
                        <div class="item-title"></div>
                      </div>{" "}
                    </div>
                    <h3
                      className="title"
                      style={{
                        fontFamily: "Playfair Display",
                        fontSize: "20px",
                        fontWeight: "700",
                        textAlign: "center",
                      }}
                    >
                      Board-Style Question Bank
                    </h3>
                  </div>
                </div>
                <div class="col aboutItem">
                  <div class="about-item">
                    {" "}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div class="item-icon-title">
                        <div class="item-icon">
                          <i class="fa-solid fa-highlighter"></i>
                        </div>
                        <div class="item-title"></div>
                      </div>{" "}
                    </div>
                    <h3
                      className="title"
                      style={{
                        fontFamily: "Playfair Display",
                        fontSize: "20px",
                        fontWeight: "700",
                        textAlign: "center",
                      }}
                    >
                      High Yield Study Resources
                    </h3>
                  </div>
                </div>
                <div class="col aboutItem">
                  <div class="about-item" style={{ paddingBottom: "54px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div class="item-icon-title">
                        <div class="item-icon">
                          <i class="fa-solid fa-file-arrow-up"></i>
                        </div>
                        <div class="item-title"></div>
                      </div>{" "}
                    </div>
                    <h3
                      className="title"
                      style={{
                        fontFamily: "Playfair Display",
                        fontSize: "20px",
                        fontWeight: "700",
                        textAlign: "center",
                      }}
                    >
                      Updated Content
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="section p-5">
    <div className="container">
        <div className="row">
            <div className="col-md-4">
<div className="elementContainer">
    <div className="elementContainerInner">
        <div className="elementContainerInner2">
            <div className="elementContainerInnerContent">
                <div className="elementContainerInnerTitle">
                    <h3>
                    Revolutionizing Medical Education: A First Look At Maps Medics
                    </h3>
                    <div className="elementContainerInnerDesc">
                    Discover the power of Maps Medics e-learning platform in our introductory video. Learn about our comprehensive case-based approach, extensive video library, top-notch question bank, and personalized support
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
            </div>
            <div className="col-md-8">
                <img src={blog3} alt="" style={{borderRadius:'10px'}} />
                </div>
        </div>
    </div>
</div> */}
      <div className="section section-padding">
        <div className="container">
          <div className="row">
            <Swiper
              // install Swiper modules
              modules={[
                Navigation,
                Pagination,
                Autoplay,
                EffectFade,
                EffectFlip,
                EffectCoverflow,
                EffectCube,
              ]}
              spaceBetween={50}
              slidesPerView={5}
              // navigation
              // scrollbar={{ draggable: true }}
              autoplay={true}
              loop
              style={{ marginBottom: "5%", marginTop: "5%" }}
              className="swiperHome"
            >
              <SwiperSlide
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              >
                {" "}
                <a href="https://www.usmle.org/" target="_blank">
                  {" "}
                  <img src={cer1} alt="" style={{ width: "90%" }} />
                </a>
              </SwiperSlide>
              <SwiperSlide
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              >
                {" "}
                <a href="https://www.nbme.org/" target="_blank">
                  {" "}
                  <img src={cer2} alt="" style={{ width: "90%" }} />
                </a>
              </SwiperSlide>
              <SwiperSlide
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              >
                {" "}
                <a href="http://www.mti.edu.eg/" target="_blank">
                  {" "}
                  <img src={cer3} alt="" style={{ width: "90%" }} />
                </a>
              </SwiperSlide>
              <SwiperSlide
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              >
                {" "}
                <a href="https://www.fsmb.org/" target="_blank">
                  <img src={cer4} alt="" style={{ width: "90%" }} />
                </a>{" "}
              </SwiperSlide>
              <SwiperSlide
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              >
                {" "}
                <a href="https://www.ecfmg.org/" target="_blank">
                  <img src={cer5} alt="" style={{ width: "90%" }} />
                </a>{" "}
              </SwiperSlide>
            </Swiper>{" "}
          </div>
        </div>
      </div>
      <div class="section  download-section">
        <div
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            paddingBottom: "120px",
            paddingTop: "120px",
          }}
        >
          {/* 
<div class="app-shape-1"></div>
<div class="app-shape-2"></div>
<div class="app-shape-3"></div>
<div class="app-shape-4"></div> */}

          <div class="container">
            <div className="row">
              <div className="col-md-12">
                <div class="download-app-wrapper mt-n6">
                  <div class="section-title section-title-white">
                    <div className="row">
                      <h2
                        class="sub-title text-center"
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#ffc600",
                          margin: "0 0 15px 0",
                        }}
                      >
                        UNLOCK YOUR POTENTIAL
                      </h2>
                    </div>
                    <div className="row">
                      {" "}
                      <h3
                        class="main-title text-center"
                        style={{
                          fontSize: "46px",
                          fontWeight: "900",
                          fontFamily: "Playfair Display",
                          lineHeight: "1.2em",
                          color: "#fff",
                          margin: "0 0 5px 0",
                        }}
                      >
                        Achieve Your Aspirations And Transform Your Medical
                        Education With Maps Medics.
                      </h3>
                    </div>
                  </div>

                  {/* <img class="shape-1 animation-right" src={shape14} alt="Shape"/> */}

                  <div
                    class="download-app-btn "
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Link class="btn btn-primary startLearning" to="/courses">
                      {" "}
                      Start Learning Now{" "}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default About;
